import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
/**
 * Generated class for the FormatPhonePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatPhone',
})
export class FormatPhonePipe implements PipeTransform {
  /**
   * Takes a phone number from a CDLLife job and return a consistent format
   */
  transform(value: string, ...args) {
    if (!value) {
      return '';
    }
    let v = _.toString(value).replace(/ /g, '');
    let ext = v.match(/x\d+$/);
    let numbers = v.replace(/x\d+$/, '').replace(/\D/g, '');
    let cTen = { 0: '', 3: '-', 6: '-' };
    let cSeven = { 3: '-' };
    let i;
    let result = '';

    if (numbers.length == 11 && numbers[0] == '1') {
      numbers = numbers.slice(1);
    }

    if (numbers.length == 10) {
      for (i = 0; i < numbers.length; i++) {
        result += (cTen[i] || '') + numbers[i];
      }
    } else if (numbers.length == 7) {
      for (i = 0; i < numbers.length; i++) {
        result += (cSeven[i] || '') + numbers[i];
      }
    } else result += numbers;

    return result + ((ext && ext[0]) || '');
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-phone/format-phone.ts